import { createContext } from 'react'

import type { ColorPalette } from '@percent/domain/giving'
import { CssVariablesColorPalette } from '@percent/workplace-giving/utils/colorPaletteToCssVariables'

type ColorThemeContext = {
  theme: ColorPalette
  cssVariables: CssVariablesColorPalette
  setTheme: (theme: ColorPalette) => void
}

export const ColorThemeContext = createContext<ColorThemeContext | undefined>(undefined)
